<template>
  <div class="Navigation" @click="$emit('click')">
    <ul>
      <li class="Navigation__header">Les rubriques</li>
      <li class="Navigation__entry"><router-link :to="{name: 'Home'}">
        Accueil
      </router-link></li>
      <li class="Navigation__entry"><router-link :to="{name: 'Home'}">
        Les offres de la semaine
      </router-link></li>
      <li class="Navigation__entry"><router-link :to="{name: 'Universes'}">
        Les univers
      </router-link></li>
      <li class="Navigation__entry"><a @click.prevent="search" href="#">
        Rechercher un vin
      </a></li>
    </ul>

    <ul>
      <li class="Navigation__header">Mon compte</li>
      <li class="Navigation__entry"><router-link :to="{name: 'Profile'}">
        Mes informations
      </router-link></li>
      <li class="Navigation__entry"><router-link :to="{name: 'Orders'}">
        Mes Commandes
      </router-link></li>
      <li class="Navigation__entry"><router-link :to="{name: 'Cart'}">
        Mon Panier ({{ lineCount }})
      </router-link></li>
      <li class="Navigation__entry" data-cy="logout" @click="logout"><a href="#">
        Déconnexion
      </a></li>
    </ul>

    <ul>
      <li class="Navigation__separator"></li>
      <li class="Navigation__header"><router-link :to="{name: 'Agent'}">
        Mon Captain
      </router-link></li>
      <li class="Navigation__entry"><router-link :to="{name: 'About'}">
        Qui Sommes-Nous ?
      </router-link></li>
    </ul>

    <ul>
      <li class="Navigation__separator"></li>
      <li class="Navigation__header">Contactez-nous</li>
      <li class="Navigation__entry">+33 1 45 25 51 23</li>
      <li class="Navigation__entry"><a class="Navigation__email" href="mailto:captain@captainvin.com">captain@captainvin.com</a></li>
    </ul>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters("cart", ["lineCount"]),
  methods: {
    logout() {
      this.$store.dispatch("auth/logout")
        .then(() => {
          this.$store.commit("cart/resetCart");
          this.$router.push("/login");
        });
    },
    search() {
      const searchInput = document.querySelector("#search-input");

      if (searchInput && searchInput.getBoundingClientRect().height > 0) {
        searchInput.focus();
      } else {
        this.$router.push({ name: "Search" });
      }
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.Navigation {
  display: block;
  padding: 1.5*$global-margin 2*$global-margin;
  color: #fff;
  background-color: $color-black;
  font-size: 0.875rem;

  &__header {
    margin: 0 0 0.5*$global-margin;
    font-weight: 900;
    text-transform: uppercase;
  }

  & > ul:not(:last-child)::after {
    display: inline-block;
    content: '—';
    font-weight: 900;
    margin: 0.5em 0;
  }

  &__entry {
    display: flex;
    flex-flow: column;
    padding: 0.5*$global-margin 0.75*$global-margin;
    text-transform: uppercase;
    color: currentColor;
  }

  &__email {
    text-transform: none;
  }

  a {
    color: currentColor;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (min-width: 900px) {
  .Navigation__entry {
    padding: 0;
  }

  .Footer .Navigation {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    ul::after {
      display: none;
    }

    ul:last-child {
      order: -1;
    }
  }
}
</style>
